import { Layout, theme } from 'antd'
import React from 'react'

const { Content } = Layout

interface UnauthenticatedProps {
    children: React.ReactNode
}

export const UnauthenticatedLayout: React.FC<UnauthenticatedProps> = ({ children }) => {
    const {
        token: { colorBgContainer, borderRadiusLG }
    } = theme.useToken()

    return (
        <Layout>
            <Content
                style={{
                    margin: '24px 16px',
                    padding: 24,
                    minHeight: 280,
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG
                }}
            >
                {children}
            </Content>
        </Layout>
    )
}
